import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cached = null; // null = nog niet geladen
let inflight = null;

/**
 * Geeft { loaded, showBlog } terug. showBlog = er is minstens 1 gepubliceerd
 * artikel; daarmee verschijnen/verdwijnen het menu-item en de footerlink Blog.
 */
export function useBlogStatus() {
    const [state, setState] = useState({
        loaded: cached !== null,
        showBlog: cached === true,
    });

    useEffect(() => {
        if (cached !== null) {
            setState({ loaded: true, showBlog: cached });
            return;
        }
        let alive = true;
        if (!inflight) {
            inflight = axios
                .get(`${API}/blog/status`)
                .then((r) => (r.data?.published || 0) > 0)
                .catch(() => false);
        }
        inflight.then((v) => {
            cached = v;
            if (alive) setState({ loaded: true, showBlog: v });
        });
        return () => {
            alive = false;
        };
    }, []);

    return state;
}
